export const Nodes = {
  
    paragraph: {
        name: 'paragraph'
    },
  
    blockquote: {
        name: 'blockquote'
    },
  
    heading: {
        name: 'heading'
    },
  
    bulletList: {
        name: 'bulletList'
    },
  
    orderedList: {
        name: 'orderedList'
    },
  
    listItem: {
        name: 'listItem'
    },
  
    link: {
        name: 'link'
    },
  
    bold: {
        name: 'bold'
    },
  
    italic: {
        name: 'italic'
    },
  
    textStyle: {
        name: 'textStyle'
    },
  
    color: {
        name: 'color'
    },
  
    image: {
        name: 'image'
    },

    customImage: {
        name: 'customImage'
    }
}
